import { JsonObject, JsonProperty } from 'json2typescript';
import { RouteConfiguration } from '../route-configuration-model';

@JsonObject('AwsSftpConfiguration')
export class AwsSftpConfiguration extends RouteConfiguration {
  @JsonProperty('fileMask', String, true) fileMask: string = undefined;
  @JsonProperty('daysReading', [String], true) daysReading: string[] = undefined;
}
